const COMMON_KEYS = ['userType', 'userStatus'], MAX_ATTEMPTS = 3, TIME_TO_RETRY = 250, DEVICE_TYPES = {
    DESKTOP: 'desktop',
    MOBILE: 'mobile',
    TABLET: 'tablet',
};
export { COMMON_KEYS, DEVICE_TYPES, MAX_ATTEMPTS, TIME_TO_RETRY };
//# sourceMappingURL=tracking.constants.js.map